import type { onStoreChangeT } from '../../../labelling/types';
import { useOnStoreChange } from '../../hooks/use-on-store-change';
type Props = {
  onStoreChange: onStoreChangeT;
};
export const OutputObserver = ({
  onStoreChange
}: Props) => {
  useOnStoreChange(onStoreChange);
  return null;
};